import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("mj_token") ||
    localStorage.getItem("mj_admin_token") ||
    localStorage.getItem("mj_rider_token");
  const url = config.url || "";
  if (url.startsWith("/admin")) {
    const adminTok = localStorage.getItem("mj_admin_token");
    if (adminTok) config.headers.Authorization = `Bearer ${adminTok}`;
  } else if (url.startsWith("/rider")) {
    const riderTok = localStorage.getItem("mj_rider_token");
    if (riderTok) config.headers.Authorization = `Bearer ${riderTok}`;
  } else if (token && localStorage.getItem("mj_token")) {
    config.headers.Authorization = `Bearer ${localStorage.getItem("mj_token")}`;
  }
  return config;
});
